import React from "react";
import styles from "./BreadCrumbs.module.scss";
import { Breadcrumb } from "react-bootstrap";
import classNames from "classnames";
import { Link, useLocation } from "react-router-dom";
import {
  FiBox,
  FiCpu,
  FiDatabase,
  FiGrid,
  FiLayers
} from "react-icons/fi";
export interface InputBreadCrumbs {
  breadCrumbsData: {
    name?: string;
    url: string;
    hidden?: boolean;
    isActive?: boolean;
    onClick?: () => void;
  }[];
}

const getBreadcrumbIcon = (
  name?: string
): { icon: JSX.Element; color: string } | null => {
  if (!name) {
    return null;
  }
  if (name === "Import Data Model") {
    return { icon: <FiBox />, color: "#0f766e" };
  }
  if (name === "Data Source Modelling") {
    return { icon: <FiDatabase />, color: "#cd7f32" };
  }
  if (name === "Ensemble Modelling") {
    return { icon: <FiLayers />, color: "#2563eb" };
  }
  if (name === "Data Vault Modelling") {
    return { icon: <FiCpu />, color: "#9fa6ad" };
  }
  if (name === "Data Mart Modelling") {
    return { icon: <FiGrid />, color: "#d4af37" };
  }
  return { icon: <FiBox />, color: "#64748b" };
};

const BreadCrumbs = (props: InputBreadCrumbs) => {
  const location = useLocation();
  const { breadCrumbsData } = props;
  const visibleBreadCrumbs = breadCrumbsData.filter(
    (breadCrumb) => breadCrumb.hidden !== true
  );
  const hasExplicitActive = visibleBreadCrumbs.some(
    (breadCrumb) => breadCrumb.isActive !== undefined
  );
  const activeLinkIndex = visibleBreadCrumbs.findIndex(
    (breadCrumb) => breadCrumb.url === location.pathname
  );
  return (
    <div className={styles.BreadcrumbContainer}>
      <Breadcrumb className={styles.Breadcrumb}>
        {visibleBreadCrumbs.map((item, index) => {
          const breadcrumbItemClass = classNames(styles.BreadcrumbItem, {
            [styles.active]: hasExplicitActive
              ? item.isActive === true
              : index === activeLinkIndex,
          });
          const iconConfig = getBreadcrumbIcon(item.name);
          return (
            <Breadcrumb.Item key={index} className={breadcrumbItemClass}>
              {item.onClick ? (
                <button
                  type="button"
                  onClick={item.onClick}
                  className={styles.BreadcrumbButton}
                >
                  {iconConfig ? (
                    <span
                      className={styles.BreadcrumbIcon}
                      style={{ color: iconConfig.color }}
                      aria-hidden="true"
                    >
                      {iconConfig.icon}
                    </span>
                  ) : null}
                  {item.name}
                </button>
              ) : (
                <Link to={item.url}>
                  {iconConfig ? (
                    <span
                      className={styles.BreadcrumbIcon}
                      style={{ color: iconConfig.color }}
                      aria-hidden="true"
                    >
                      {iconConfig.icon}
                    </span>
                  ) : null}
                  {item.name}
                </Link>
              )}
            </Breadcrumb.Item>
          );
        })}
      </Breadcrumb>
      <hr />
    </div>
  );
};

export default BreadCrumbs;
